import React, {Component, Fragment} from 'react';
import Header from "../../Header";
import {BrowserRouter as Router, Route, Switch, withRouter} from 'react-router-dom';
import LiveContainer from "../Live/LiveContainer";
import RightSide from "../../RightSide";
import LeftSide from "../../LeftSide";
import LiveById from "../LiveById/LiveById";
import LineLeagues from "../LineLeagues/LineLeagues";
import LineSelectContainer from "../LineSelect/LineSelectContainer";
import NewsContainer from "../News/NewsContainer";
import LiveSoonContainer from "../LiveSoon/LiveSoonContainer";
import Modal from "../../components/Modal";
import NewsFull from "../News/NewsFull";
import Auth from "../Auth/Auth";
import SideLeft from "../../SideLeft";
import Coupon from "../../components/Coupon/Coupon";
import Oneclick from "../../components/Oneclick";
import Footer from "../../Footer";
import Statistic from "../Statistic/Statistic";
import ResultLiveContainer from "..\/Result/Live/ResultLiveContainer";
import UserMenu from "../User/UserMenu";
import UserContainer from "../User/UserContainer";
import Page from "../Page/PageContainer";
import Register from "../Auth/Register";
import UserForgot from "../User/UserForgot";
import UserRestore from "../User/UserRestore";
import ResultLineContainer from "../Result/Line/ResultLineContainer";
import {connect} from "react-redux";
import Tracker from "../../components/Tracker";
import {getFactors, setVisit} from "../../redux/actions/main";
import PageNotFound from "../Page/PageNotFound";
import Search from "../Search/Search";
import Betgames from "../Betgames/Betgames";
import $ from "jquery";

const HomePage = () => (
	<div className="body__content">
		<LeftSide/>

		<Switch>
			<Route exact path="/live" component={LiveContainer}/>
			<Route exact path="/live-soon" component={LiveSoonContainer}/>
			<Route exact path="/result/live" component={ResultLiveContainer}/>
			<Route exact path="/result/line" component={ResultLineContainer}/>
			<Route exact path="/search" component={Search}/>

			<Route exact path="/line-select/:sports" component={({match}) =>
				<LineSelectContainer sports={match.params.sports}/>}/>

			<Route exact path="/news/type/:type" component={({match}) => <NewsContainer type={match.params.type}/>}/>
			<Route exact path="/news/:type/:slug" component={({match}) =>
				<NewsFull type={match.params.type} slug={match.params.slug}/>}/>

			<Route exact path="/user/forgot" component={UserForgot}/>
			<Route exact path="/user/restore/:hash" component={({match}) => <UserRestore hash={match.params.hash}/>}/>

			<Route exact path="/top-live" component={() => <RightSide isTopLive={true}/>}/>
			<Route exact path="/" component={RightSide}/>
		</Switch>
	</div>
);

const LiveId = ({match}) => (
	<div className="body__content">
		<LiveById events={match.params.id}/>

		<SideLeft>
			<div className="fixed">
				<Tracker/>
				<Oneclick type="live"/>
				<Coupon type="live"/>
			</div>
		</SideLeft>
	</div>
);

const LiveSportPage = ({match}) => (
	<div className="body__content">
		<LiveById sports={match.params.id}/>

		<SideLeft>
			<div className="fixed">
				<Tracker/>
				<Oneclick type="live"/>
				<Coupon type="live"/>
			</div>
		</SideLeft>
	</div>
);

const LineLeaguesPage = ({match}) => (
	<div className="body__content">
		<LineLeagues leagues={match.params.leagues || null}
		             sports={match.params.sports || null}
		             event_id={match.params.event_id || null}
		             sport_slug={match.params.sportSlug || null}
		             popular_slug={match.params.popularSlug || null}
		             several={match.params.several || null}/>

		<SideLeft>
			<Coupon type="line"/>
		</SideLeft>
	</div>
);

const AuthPage = () => (
	<div className="body__content">
		<Auth/>
	</div>
);

const StatisticPage = () => (
	<div className="body__content">
		<Statistic/>
	</div>
);

const UserPage = () => (
	<div className="body__content">
		<UserMenu/>
		<UserContainer/>
	</div>
);

const UserSignUpPage = () => (
	<div className="body__content">
		<Register/>
	</div>
);

const StaticPage = () => (
	<div className="body__content">
		<Page/>
	</div>
);

const NotFound = () => (
	<div className="body__content">
		<PageNotFound/>
	</div>
);

class Main extends Component {
	componentWillMount() {
		this.props.onGetFactors();
		if ( this.props.main.isFirstVisit ) {
			this.props.onSetVisit();
		}

		// при смене роута скроллим старицу вверх
		this.unlisten = this.props.history.listen((location, action) => {
			const $pageContent = $(window);
			$pageContent.scrollTop(0);
		});
	}

	componentWillUnmount() {
		this.unlisten();
	}

	scrollTop() {
		$('body,html').animate({scrollTop : 0}, 800);
	}

	scrollDown() {
		const n = $(document).height();
		$('body,html').animate({scrollTop : n}, 800);
	}

	render() {
		return (
			<Fragment>
				<div className="body__container">
					<Header/>

					<div className="container">
						<Switch>
							<Route exact path="/live/:id" component={LiveId}/>
							<Route exact path="/favourites" component={NotFound}/>
							<Route exact path="/favourites/:id" component={LiveId}/>
							<Route exact path="/live-sport/:id" component={LiveSportPage}/>

							<Route exact path="/line-leagues/:leagues" component={LineLeaguesPage}/>
							<Route exact path="/line-leagues/:leagues/:event_id" component={LineLeaguesPage}/>
							<Route exact path="/line-sports/:sports" component={LineLeaguesPage}/>
							<Route exact path="/popular/:sportSlug/:popularSlug" component={LineLeaguesPage}/>
							<Route exact path="/popular/:several" component={LineLeaguesPage}/>
							<Route exact path="/auth" component={AuthPage}/>
							<Route exact path="/statistic" component={StatisticPage}/>

							<Route exact path="/user/signup" component={UserSignUpPage}/>
							<Route exact path="/user/forgot" component={HomePage}/>
							<Route exact path="/user/restore/:hash" component={HomePage}/>

							<Route exact path="/user/:page?" component={UserPage}/>
							<Route exact path="/page/:page?" component={StaticPage}/>
							<Route exact path="/betgames/:type?" component={StaticPage}/>

							<Route path="/" component={HomePage}>
								<Route exact path="live"/>
								<Route exact path="live-soon"/>
								<Route exact path="top-live"/>
								<Route exact path="result/live"/>
								<Route exact path="result/line"/>
								<Route exact path="line-select/:sports"/>
								<Route exact path="news/type/:type"/>
								<Route exact path="news/:type/:slug"/>
							</Route>
						</Switch>

						<Modal/>

						<div className="scroll-top">
							<div onClick={this.scrollTop.bind(this)}>
								<i className="fas fa-angle-up"/>
							</div>
							<div onClick={this.scrollDown.bind(this)}>
								<i className="fas fa-angle-down"/>
							</div>
						</div>
					</div>
				</div>

				<Footer/>

			</Fragment>
		);
	}
}

export default withRouter(
	connect(
		state => ({
			main : state.main,
		}),
		dispatch => ({
			onSetVisit   : () => {
				dispatch(setVisit());
			},
			onGetFactors : () => {
				dispatch(getFactors());
			}
		})
	)(Main)
);


// WEBPACK FOOTER //
// ./src/app/pages/Main/Main.js